module.exports = __webpack_public_path__ + "img/arrow-up.5f145875.svg";